module.exports = "/_next/static/images/13e82227abda2713f67cb60aa4d9b830-tencent.png.webp";